import { restApi } from '../api/restApiSlice';

import type DynamicState from './DynamicState';
import { type DynamicStateUser, type DefaultDynamicStateCompanyPatch, DynamicStateScopes } from './DynamicState';

type DynamicStateUpdateUser = {
  state: DynamicStateUser;
  scope: typeof DynamicStateScopes.User;
};

type DynamicStateUpdateCompany = {
  state: DefaultDynamicStateCompanyPatch;
  scope: typeof DynamicStateScopes.Company;
};

export type DynamicStateUpdate = DynamicStateUpdateUser | DynamicStateUpdateCompany;

export const DynamicStateApi = restApi.injectEndpoints({
  endpoints: (builder) => ({
    getDynamicState: builder.query<DynamicState, void>({
      query: () => '/v3/ui-state',
      keepUnusedDataFor: Infinity, // prevent cache invalidation
    }),
    updateDynamicState: builder.mutation<DynamicState, DynamicStateUpdate>({
      query: ({ state, scope }) => ({
        url: `/v3/ui-state/${scope}`,
        method: 'POST',
        body: {
          state,
        },
      }),
    }),
  }),
});

export const { useGetDynamicStateQuery, useLazyGetDynamicStateQuery, useUpdateDynamicStateMutation } = DynamicStateApi;
